<div class="modal-header">
    <div class="modal-title">Matriz de objetivos de la acción</div>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>
<div class="modal-body" *ngIf="model">
    <h4>Acción {{model.Action}}</h4>


    <section  class="grey-tabs">
        <ul [(activeId)]="activeId" ngbNav #nav="ngbNav" class="nav-tabs mt-3">
            <li *ngFor="let elem of model.Groups;let i = index" [ngbNavItem]="i" ngbNavItem>
                <a ngbNavLink>{{elem.Group}}</a>
                <ng-template ngbNavContent>
                    <div class="row">
                        <div class="col-md-5" *ngIf="elem.PvGroups.length>0">
                            <a ngbNavLink>Grupos PV de {{elem.Group}}</a>
                            <ul>
                                <li *ngFor="let elem2 of elem.PvGroups">
                                    {{elem2.PvGroupName}}
                                </li>
                            </ul>
                        </div>
                        <div [ngClass]="elem.PvGroups.length==0 ? 'col-md-12' : 'col-md-7'">
                            <div class="row" *ngFor="let subaction of elem.Subactions">
                                <div class="col-md-12" *ngIf="subaction.Goals && subaction.Goals.length > 0">
                                    <table class="table table-striped w-100 table__resume no-footer">
                                        <thead>
                                            <tr>
                                                <th colspan="2" class="bg-darkgrey">Rangos de incentivo subacción
                                                    {{subaction.Title}}</th>
                                            </tr>
                                            <tr>
                                                <th class="w-50">Objetivo</th>
                                                <th class="w-50">Remuneración</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let goal of subaction.Goals">
                                                <td>
                                                    {{goal.Units}}
                                                </td>
                                                <td>
                                                    {{goal.Price | currency: 'EUR'}}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="col-md-12" *ngIf="!subaction.Goals || subaction.Goals.length == 0">
                                    <div class="info__box"><img
                                            src="../../../../../assets/images/icons/icon-info-black.svg">
                                        <div>No tienes ninguna tabla de incentivos configurada para la subacción
                                            {{subaction.Title}}.</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </li>
        </ul>
    </section>

    <div class="col-md-12" *ngIf="model.Groups.length==0">
        <div class="info__box"><img
                src="../../../../../assets/images/icons/icon-info-black.svg">
            <div>No tienes ninguna subacción para esta acción</div>
        </div>
    </div>

    <div *ngIf="model.Groups.length>0" [ngbNavOutlet]="nav" class="bg-grey min-height-finish card-documents"></div>


</div>